export const getUsername = (state) => state.login.userName;
export const getToken = (state) => state.login.token;
export const getIsLoginLoading = (state) => state.login.isLoginLoading;
export const getLoginError = (state) => state.login.loginError;
export const isLoggedin = (state) => state.login.isLoggedin;



// WEBPACK FOOTER //
// ./src/stores/Login/Selector.js